'use client';

import { c as _c } from "react/compiler-runtime";
import type { HTMLRendererProps } from '@src/components/HTMLRenderer/HTMLRenderer.props';
import ShadowRoot from '@src/utils/ShadowRoot';
export const HTMLRenderer = props => {
  const $ = _c(2);
  const {
    srcDoc: t0
  } = props;
  const srcDoc = t0 === undefined ? "" : t0;
  let t1;
  if ($[0] !== srcDoc) {
    t1 = <ShadowRoot><div dangerouslySetInnerHTML={{
        __html: srcDoc
      }} /></ShadowRoot>;
    $[0] = srcDoc;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};